module.exports = __webpack_public_path__ + "img/chb.9a5583c0.png";